"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Code copied from https://github.com/henrymoews/simplified-reflux and modified afterwards
 */
var GenericStore = /*#__PURE__*/function () {
  function GenericStore() {
    (0, _classCallCheck2["default"])(this, GenericStore);
    this.state = this.initialState();
    this.listeners = {};
    this.components = {};
  }

  (0, _createClass2["default"])(GenericStore, [{
    key: "initialState",
    value: function initialState() {
      return {};
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
  }, {
    key: "addListener",
    value: function addListener(keys, listener) {
      var _this = this;

      keys.forEach(function (key) {
        if (!_this.listeners[key]) {
          _this.listeners[key] = [];
        }

        _this.listeners[key].push(listener);
      });
    }
  }, {
    key: "addListenerComponent",
    value: function addListenerComponent(keys, component) {
      var state = {};

      var _iterator = _createForOfIteratorHelper(keys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;

          if (!this.components[key]) {
            this.components[key] = [];
          }

          this.components[key].push(component);
          state[key] = this.getStateForPathParts(key.split('.'), this.state);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return state;
    }
  }, {
    key: "removeListener",
    value: function removeListener(keys, listener) {
      var _this2 = this;

      keys.forEach(function (key) {
        if (_this2.listeners[key]) {
          var index = _this2.listeners[key].indexOf(listener);

          if (index > -1) {
            _this2.listeners[key].splice(index, 1);
          }
        }
      });
    }
  }, {
    key: "removeListenerComponent",
    value: function removeListenerComponent(keys, component) {
      var _this3 = this;

      keys.forEach(function (key) {
        if (_this3.components[key]) {
          var index = _this3.components[key].indexOf(component);

          _this3.components[key].splice(index, 1);
        }
      });
    }
  }, {
    key: "setValue",
    value: function setValue(key, value) {
      var dict = {};
      dict[key] = value;
      this.setValues(dict);
    }
  }, {
    key: "makeCopy",
    value: function makeCopy(value) {
      return JSON.parse((0, _stringify["default"])(value));
    }
  }, {
    key: "getStateForPathParts",
    value: function getStateForPathParts(pathParts, state) {
      return pathParts.reduce(function (acc, val, index) {
        if (!acc) {
          return null;
        }

        if (!acc[val]) {
          if (index < 1) {
            return null; // no creation on first level!
          }

          if (index < pathParts.length - 1) {
            acc[val] = {};
          }
        }

        return acc[val];
      }, state);
    }
  }, {
    key: "setStateForPath",
    value: function setStateForPath(path, value) {
      var pathParts = path.split('.');
      var stateCopy = this.makeCopy(this.state);
      var element = this.getStateForPathParts(pathParts.slice(0, -1), stateCopy);

      if (element) {
        element[pathParts.slice(-1)] = value;
      }

      this.state = stateCopy;
    }
  }, {
    key: "setValues",
    value: function setValues(dict) {
      var _this4 = this;

      var listenersToCall = [];
      var componentsToUpdate = [];
      (0, _keys["default"])(dict).forEach(function (key) {
        if (_this4.listeners[key] && listenersToCall.indexOf(_this4.listeners[key]) < 0) {
          listenersToCall.push.apply(listenersToCall, (0, _toConsumableArray2["default"])(_this4.listeners[key]));
        }

        if (_this4.components[key]) {
          _this4.components[key].forEach(function (component) {
            var compAndState = componentsToUpdate.find(function (compAndState) {
              return compAndState.component === component;
            });

            if (!compAndState) {
              var state = {};
              state[key] = dict[key];
              componentsToUpdate.push({
                component: component,
                state: state
              });
            } else {
              compAndState.state[key] = dict[key];
            }
          });
        }

        _this4.setStateForPath(key, dict[key]);
      });
      listenersToCall.forEach(function (listener) {
        if (listener.current) {
          listener.current();
        } else {
          listener();
        }
      });
      componentsToUpdate.forEach(function (componentAndState) {
        _this4.updateStateInComponent(componentAndState.component, componentAndState.state);
      });
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      return this.state[key];
    }
  }, {
    key: "updateStateInComponent",
    value: function updateStateInComponent(component, state) {
      if (component.mapStoreToState) {
        var updateObj = component.mapStoreToState(this, state);

        if (updateObj) {
          component.setState(updateObj);
          return;
        }
      }

      component.setState(state);
    }
  }]);
  return GenericStore;
}();

var _default = GenericStore;
exports["default"] = _default;